import { useEffect } from 'react';
import { SnackbarProvider as NotistackSnackbarProvider, useSnackbar } from 'notistack';
import Snackbar from 'src/components/Snackbar';
import { setGlobalSnackbarContext } from 'src/utils/snackbar';

interface ISnackbarProvider {
    children: React.ReactNode;
}

function SnackbarContextInitializer() {
    const context = useSnackbar();

    useEffect(() => {
        setGlobalSnackbarContext(context);
        return () => {
            setGlobalSnackbarContext(null);
        };
    }, [context]);

    return null;
}

export default function SnackbarProvider({ children }: ISnackbarProvider) {
    return (
        <NotistackSnackbarProvider
            Components={
                {
                    default: Snackbar,
                    error: Snackbar,
                    warning: Snackbar,
                    success: Snackbar,
                    info: Snackbar,
                } as any
            }
            maxSnack={5}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
        >
            <SnackbarContextInitializer />
            {children}
        </NotistackSnackbarProvider>
    );
}
